"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualPage = exports.Name = void 0;
const Name = exports.Name = 'virtual-page';
const VirtualPage = exports.VirtualPage = Name;
//# sourceMappingURL=index.js.map